export function selectData<TResponse extends { data: unknown }>({
  data,
}: TResponse): TResponse["data"] {
  return data;
}
